import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, StarIcon, TrophyIcon } from 'lucide-react';
export function SocialProofBar() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-8 px-4 bg-card/50" data-id="element-129">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-130">
        <div className="flex flex-col items-center gap-2" data-id="element-131">
          <UsersIcon className="w-8 h-8 text-accent" data-id="element-132" />
          <p className="text-2xl font-bold" data-id="element-133">500+</p>
          <p className="text-gray-400 text-sm" data-id="element-134">Profesores ya lo usan</p>
        </div>
        <div className="flex flex-col items-center gap-2" data-id="element-135">
          <StarIcon className="w-8 h-8 text-accent" data-id="element-136" />
          <p className="text-2xl font-bold" data-id="element-137">4.9/5</p>
          <p className="text-gray-400 text-sm" data-id="element-138">Valoración promedio</p>
        </div>
        <div className="flex flex-col items-center gap-2" data-id="element-139">
          <TrophyIcon className="w-8 h-8 text-accent" data-id="element-140" />
          <p className="text-2xl font-bold" data-id="element-141">100%</p>
          <p className="text-gray-400 text-sm" data-id="element-142">Resultados comprobados</p>
        </div>
      </div>
    </motion.section>;
}